import React from "react";
import { Box, Button, FormControlLabel, Modal, Radio, RadioGroup, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import InfoIcon from "@mui/icons-material/Info";
import { toast } from "react-toastify";
import payment from "../../images/logo card.png";

const useStyles = makeStyles(() => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: "#0F2E30",
    borderRadius: "8px",
    padding: "32px",
    color: "white",
    width: "100%",
    maxWidth: "1000px",
  },
  contentWrapper: {
    display: "flex",
    gap: "24px",
    flexWrap: "wrap",
  },
  leftSide: {
    flex: "1 1 300px",
  },
  rightSide: {
    flex: "1 1 300px",
    backgroundColor: "#283E40",
    borderRadius: "8px",
    padding: "16px",
  },
  paymentOption: {
    cursor: "pointer",
    backgroundColor: "#283E40",
    borderRadius: "8px",
    padding: "16px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
    transition: "background-color 0.3s ease",
    "& .Mui-checked ~ &": {
      backgroundColor: "#7B2CBF", // fallback if you could target, but RadioGroup structure makes this tricky.
    },
  },
  paymentDetails: {
    display: "flex",
    alignItems: "center",
  },
  paymentImage: {
    width: "50px",
    height: "50px",
    marginRight: "16px",
    objectFit: "contain",
  },
  totalSection: {
    marginTop: "16px",
  },
  continueButton: {
    backgroundColor: "#EEBA0E !important",
    color: "#4B0082",
    fontWeight: "bold",
    marginTop: "26px",
    "&:hover": {
      backgroundColor: "#FFC700",
    },
  },
  selected: {
    backgroundColor: "#1c756e !important",
    border: "2px solid rgb(247, 246, 241)", // Optional: add a nice border
  },
}));

const RechargePaymentModal = ({ openRechargeModal, setOpenRechargeModal, Image, title, selectedRecharge }) => {
  const classes = useStyles();
  const handleClose = () => setOpenRechargeModal(false);
  const [selectedValue, setSelectedValue] = React.useState("");

  const handleSelect = (value) => {
    setSelectedValue(value);
  };
  const Payment = () => {
    if (!selectedValue) {
      toast.error("Please selecte the Payment options.");
      return;
    }
    toast.error("Payment options are currently unavailable. Please visit the site again later.");
  };
  return (
    <Modal className={classes.modal} onClose={handleClose} open={openRechargeModal}>
      <Box className={classes.paper}>
        <Box display="flex" justifyContent="flex-end">
          <Button onClick={handleClose} style={{ color: "white", minWidth: "auto" }}>
            ✕
          </Button>
        </Box>
        <Typography color={"white"} gutterBottom variant="h6">
          Choose Payment Method
        </Typography>
        <Box className={classes.contentWrapper}>
          <Box className={classes.leftSide}>
            <RadioGroup value={selectedValue}>
              <Box className={`${classes.paymentOption} ${selectedValue === "eneba" ? classes.selected : ""}`} onClick={() => handleSelect("eneba")}>
                <Box className={classes.paymentDetails}>
                  <img
                    alt="Eneba Wallet"
                    className={classes.paymentImage}
                    src="https://epay-world.s3.ap-northeast-2.amazonaws.com/1744116238793_551671759.png"
                  />
                  <Box>
                    <Typography color="white" fontWeight="bold" variant="body1">
                      Epayworld Wallet
                    </Typography>
                    <Typography color="white" variant="body2">
                      Total available balance:{" "}
                      <img src={"/aed-w.png"} alt={"aed"} height={"20px"} width={"20px"} style={{ objectFit: "contain" }} className="display-inline " /> 0.00
                    </Typography>
                  </Box>
                </Box>
                <FormControlLabel control={<Radio checked={selectedValue === "eneba"} />} value="eneba" label="" />
              </Box>

              <Box className={`${classes.paymentOption} ${selectedValue === "card" ? classes.selected : ""}`} onClick={() => handleSelect("card")}>
                <Box className={classes.paymentDetails}>
                  <img alt="Credit or Debit Card" className={classes.paymentImage} src={payment} style={{ backgroundColor: "#152839", borderRadius: "5px" }} />
                  <Box>
                    <Typography color="white" fontWeight="bold" variant="body1">
                      Credit or debit card
                    </Typography>
                    <Typography color="white" variant="body2">
                      Pay via Visa, Mastercard, or Maestro debit or credit card
                    </Typography>
                  </Box>
                </Box>
                <FormControlLabel control={<Radio checked={selectedValue === "card"} />} value="card" label="" />
              </Box>
            </RadioGroup>
          </Box>

          <Box className={classes.rightSide}>
            <Box className={classes.rightSide} display="flex" alignItems="center">
              <img alt="Credit or Debit Card" src={Image} style={{ width: "60px", height: "60px", marginRight: "16px", borderRadius: "8px" }} />
              <Box>
                <Typography color="white" variant="subtitle1" gutterBottom>
                  {selectedRecharge?.recharge?.description}
                </Typography>
                <Typography sx={{ textTransform: "capitalize" }} color="white" variant="body2">
                  {selectedRecharge?.type} | <span style={{ color: "#13d3c3" }}>{title}</span>
                </Typography>
              </Box>
            </Box>

            <Box color={"white"} className={classes.totalSection}>
              <Box display="flex" justifyContent="space-between">
                <Typography color={"white"} variant="body2">
                  Sub-total
                </Typography>
                <Typography color={"white"} variant="body2">
                  <img src={"/aed-w.png"} alt={"aed"} height={"20px"} width={"20px"} style={{ objectFit: "contain" }} className="display-inline " />{" "}
                  {selectedRecharge?.recharge?.prices?.retail?.amount}
                </Typography>
              </Box>
              {/* <Box display="flex" justifyContent="space-between">
                <Typography color={"white"} variant="body2">
                  Service fee <InfoIcon fontSize="small" />
                </Typography>
                <Typography color={"white"} variant="body2">
                  AED 2.13
                </Typography>
              </Box> */}
              <Box display="flex" justifyContent="space-between" mt={2} fontWeight="bold">
                <Typography color={"white"}>Total:</Typography>
                <Typography color={"white"}>
                  {" "}
                  <img src={"/aed-w.png"} alt={"aed"} height={"20px"} width={"20px"} style={{ objectFit: "contain" }} className="display-inline " />{" "}
                  {selectedRecharge?.recharge?.prices?.retail?.amount}
                </Typography>
              </Box>
              <Button onClick={Payment} className={classes.continueButton} fullWidth>
                Pay
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default RechargePaymentModal;
